'use client';

import { useToast } from '@dolcevia/lib/hooks/useToast';
import { sendEmail } from '@dolcevia/lib/send-email';
import { Button } from '@dolcevia/ui/components/ui/button';
import { Input } from '@dolcevia/ui/components/ui/input';
import { Textarea } from '@dolcevia/ui/components/ui/textarea';
import { CheckCircledIcon, ReloadIcon } from '@radix-ui/react-icons';
import { useTranslations } from 'next-intl';
import { type FormEvent, useState } from 'react';

export const ContactForm = () => {
  const { toast } = useToast();
  const t = useTranslations('Contact.form');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    setIsLoading(true);
    e.preventDefault();
    const response = await sendEmail({
      email: e.currentTarget.email.value,
      message: e.currentTarget.message.value,
      subject: e.currentTarget.subject.value,
    });
    if (response.status !== 200) {
      toast({
        variant: 'destructive',
        title: 'Uh oh! Something went wrong.',
        description:
          "Une erreur s'est produite lors de l'envoi de votre message.",
      });
    } else {
      setIsSuccess(true);
      toast({
        title: 'Message envoyé.',
        description:
          'Nous avons bien reçu votre message. Nous vous répondrons dans les plus bref délais.',
      });
    }
    setIsLoading(false);
  }

  return (
    <form
      className="flex flex-col gap-4 justify-between"
      onSubmit={async (e) => await onSubmit(e)}
    >
      <div className="grid">
        <label
          htmlFor="email"
          className="mb-3 block text-base font-medium text-deep-blue-100"
        >
          {t('Adresse email')}
        </label>
        <Input
          type="email"
          placeholder="example@gmail.com"
          required
          id="email"
        />
      </div>
      <div className="grid">
        <label
          htmlFor="subject"
          className="mb-3 block text-base font-medium text-deep-blue-100"
        >
          {t('Sujet')}
        </label>
        <Input
          type="text"
          placeholder="Exemple: comment rider un max?"
          required
          id="subject"
        />
      </div>
      <div className="flex flex-col">
        <label
          htmlFor="message"
          className="mb-3 block text-base font-medium text-deep-blue-100"
        >
          {t('Votre message')}
        </label>
        <Textarea
          rows={4}
          placeholder="Votre message"
          required
          style={{ resize: 'none' }}
          id="message"
        />
      </div>

      <Button
        variant="secondary"
        className="w-min self-center"
        type="submit"
        disabled={isLoading}
      >
        {t('button.Envoyer')}
        {isLoading && <ReloadIcon className="mr-2 h-4 w-4 animate-spin" />}{' '}
        {isSuccess && <CheckCircledIcon className="mr-2 h-4 w-4" />}
      </Button>
    </form>
  );
};
